import AppInputField from "components/shared/FormComponents/AppInputField";

const QuestionWithRadio = ({ question, fieldName }) => {
  const options = question?.question_radio_tag;
  
  return (
    <div className="iconWithText position-relative">
      {options?.length > 0 && (
        <div
          className=" position-absolute d-flex align-items-center gap-10"
          style={{ left: 5, top: 5 }}
        >
          {options.map((option, index) => (
            <label
              key={index}
              className="d-flex gap-10 rounded-pill px-3 py-1 fw-sbold themeBlue"
              style={{ background: "#F0F0F0" }}

            >
              {option}
              <AppInputField
                type="radio"
                name={`${fieldName}.other_details.radio_tag`}
                value={option}
                // style={{ opacity: "0" }}
              />
            </label>
          ))}
        </div>
      )}
      <AppInputField
        name={`${fieldName}.answer`}
        placeholder={question.placeholder}
        fieldType={"textarea"}
        rows={4}
        className="form-control rounded-3 bg-white pt-5 is-resizable-textarea"
        style={{ minHeight: "calc(8em + 0.75rem + calc(var(--bs-border-width) * 2)) !important" }}
      />
    </div>
  )
}

export default QuestionWithRadio;